module.exports = __webpack_public_path__ + "static/media/INDUSIND.f15d8998.svg";